//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      default: "text-whitency",
    },
    service: {
      type: String,
      default: "",
    },
    parentLink: {
      type: Object,
      default: () => ({
        label: "",
        link: "",
      }),
    },
    oneLevel: {
      type: Boolean,
      default: false,
    },
  },
};
